import { render, staticRenderFns } from "./latelyMessage.vue?vue&type=template&id=93eb943a&scoped=true&"
import script from "./latelyMessage.vue?vue&type=script&lang=ts&"
export * from "./latelyMessage.vue?vue&type=script&lang=ts&"
import style0 from "./latelyMessage.vue?vue&type=style&index=0&id=93eb943a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93eb943a",
  null
  
)

export default component.exports